import * as _ from 'lodash';
import React, { useEffect, useState, useContext } from 'react';
import { useForm } from 'react-hook-form';
import State from 'src/models/State';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import moment from 'moment';
// import Account from 'src/models/Account';
import PagedResultSet from 'src/models/common/PagedResultSet';
import useFetch from 'use-http';
import EmployeePay from 'src/models/personnel/EmployeePay';
import Vendor from 'src/models/AP/Vendor';
import VendorReportsDialog from '../dialogs/VendorReportsDialog';
import DialogList from 'src/dialogs';
import { useDispatch } from 'react-redux';
import actions from 'src/actions';
import AddVendorExDialog from '../dialogs/AddVendorExDialog';
import FindVendorDialog from '../dialogs/FindVendorDialog';
import WarningDialog from '../dialogs/WarningDialog';
import FindAvailableAccountsDialog from '../dialogs/FindAvailableAccountsDialog';
import APTermsDialog from '../dialogs/APTermsDialog';
import Term from 'src/models/AP/Term';
import ExcelFileDialog from '../dialogs/ExcelFileDialog';
import VendorDefaultAccount from 'src/models/AP/VendorDefaultAccount';
import { FaPlusCircle } from 'react-icons/fa';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import LedgerAccount from 'src/models/AP/GeneralLedgerAccount';
import { ODataOptions, ODataFilter, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';
import { ITableConfig } from 'src/components/common/table';
import { IAppContextState } from 'src/reducers/AppContext';
import { AppContext } from 'src/providers/AppContextProvider';
import { UserRoles } from 'src/models/UserRole';
import APNavBar from '../APNavBar';

const VendorsPage = () => {
    const dispatch = useDispatch();
    const { get, put, post, del, response } = useFetch();
    const [states, setStates] = useState<PagedResultSet<State>>(undefined);
    const [vendors, setVendors] = useState<PagedResultSet<Vendor>>(undefined);
    const [vendorDefaultAccounts, setVendorDefaultAccounts] = useState<Array<VendorDefaultAccount>>(undefined);
    const [selectedVendorDefaultAccount, setSelectedVendorDefaultAccount] = useState<number>(-1);
    const [vendorSearchOptions, setVendorSearchOptions] = useState<ODataOptions>(undefined);
    const [fetchNextPage, setFetchNextPage] = useState<boolean>(true);
    const {getValues, register, reset, handleSubmit, errors, formState, setValue } = useForm();
    const { isDirty, dirtyFields } = formState;
    const [vendorSearchTerm, setVendorSearchTerm] = useState<string>(undefined);
    const [selectedEmployeePay] = useState(undefined);
    const [selectedVendor, setSelectedVendor] = useState(0);
    const [terms, setTerms] = useState<Term[]>([
        { id: 1, termNumber: 0, description: 'Upon Receipt', days: 0 },
        { id: 2, termNumber: 1, description: 'Net 15', days: 15 },
        { id: 3, termNumber: 2, description: 'Net 30', days: 30 },
        { id: 4, termNumber: 3, description: 'Net 45', days: 45 },
    ]);
    const [termDescriptions, setTermDescriptions] = useState<{ value: string; label: string; }[]>();

    const appContext = useContext<IAppContextState>(AppContext);
    const isAccountingAdmin = appContext.currentUser.role === UserRoles.AccountingAdmin;

/*     const accounts = [
        { id: 1, accountNumber: '2-5-07-108-0000-9', description: 'A DESCRIPTION' },
        { id: 2, accountNumber: '2-5-07-108-0000-9', description: 'A DESCRIPTION' },
    ]; */

    // Initial render
    useEffect(() => {
        onCreate();

        // TODO: *cry* 😭✅
        return () => {
            onDestroy();
        };
    }, []);

    // SelectedEmployeePay changes on Update Pay
    useEffect(() => {
        console.log('resetting the form');
        reset(initializeData(selectedEmployeePay));
    }, [selectedEmployeePay]);

    useEffect(() => {
        if (!!vendors && !!vendors.items) {
            reset(vendors?.items[selectedVendor]);
        }
    }, [selectedVendor]);

    useEffect(() => {
        if (!!vendorSearchOptions) {
            getVendors(!!vendorSearchTerm ? vendorSearchTerm : '');
        }
    }, [vendorSearchOptions]);

    // Add actions to perform when the vendors list is populated
    useEffect(() => {
        if (!!vendors && vendors?.items.length > 0) {
            reset(vendors.items[selectedVendor]);
            getVendorDefaultAccounts(vendors?.items[0]?.vendorNumber);
            console.log('Vendors list retrieved!');
        }
    }, [vendors]);

    useEffect(() => {
        if (!!vendorSearchTerm || vendorSearchTerm === '') {
            // vendors.items = [];
            // setVendors(vendors);
            resetVendorSearchOptions();
        }
    }, [vendorSearchTerm]);

    /**
     * This function will be called when the Page is first rendered or the user enters the Page
     */
    const onCreate = () => {
        console.log('VendorsPage onCreate()');

        setTermDescriptions(
            terms?.map(term => ({
                value: term.description,
                label: term.description
            }))
        );

        getStates();
        initializeVendorSearchSettings();
    };

    /**
     * This function will be called when the user leaves the Page
     */
    const onDestroy = () => {
        console.log('VendorsPage onDestroy()');
    };

    /**
     * Gets the list of United States (Merica) not React states
     */
    const getStates = async () => {
        let result = await get('/v1.0/states');

        if (response.ok) {
            setStates(result);
        } else {
            console.log('Unable to get the States Data!!!');
        }
    };

    const resetVendorSearchOptions = () => {
        vendors.items = [];
        setVendors(vendors);
        setFetchNextPage(true);
        let newVendorSearchOptions = _.cloneDeep(vendorSearchOptions);
        newVendorSearchOptions.clearFilters();
        newVendorSearchOptions.addPaging(1, 50);
        // newVendorSearchOptions.addSkipTop(0, 50);
        setVendorSearchOptions(newVendorSearchOptions);
    };

    const getVendors = async (filter: string) => {
        if (!!filter && filter.length > 0) {
            if (isNaN(Number(filter))) {
                vendorSearchOptions?.addFilter(new ODataFilter('vd.NAME1', ODataFilterOperators.Contains, filter));
            } else {
                vendorSearchOptions?.addFilter(new ODataFilter('vd.VNDR_NO', ODataFilterOperators.Equals, filter));
                vendorSearchOptions?.addFilter(new ODataFilter('vd.NAME1', ODataFilterOperators.Contains, filter));
            }
        }

        const queryString = vendorSearchOptions?.toString();
        let result = await get(`/v1.0/AccountsPayable/vendors${queryString}`);

        if (response.ok) {
            if (vendorSearchOptions.getPageNumber() > 1) {
                let tempResult = _.cloneDeep(vendors);
                tempResult.items = [...tempResult.items].concat([...result.items]);
                setVendors(tempResult);
            } else {
                setVendors(result);
            }
            setFetchNextPage(result.pageNumber * result.pageSize < result.totalRecords);
        } else {
            console.log('Unable to get vendor data!!!');
        }
        vendorSearchOptions.clearFilters();
    };

    const getVendorDefaultAccounts = async (vendorNumber: number) => {
        let result = await get(`/v1.0/AccountsPayable/defaultaccounts/vendor/${vendorNumber}`);

        if (response.ok && result?.items?.length > 0) {
            setVendorDefaultAccounts([]);
            setVendorDefaultAccounts(result?.items);
        } else {
            setVendorDefaultAccounts([]);
            setVendorDefaultAccounts([{id: 0, accountNumber: 'Enter Account No', description: 'Enter Description' }]);
            console.log('Unable to get the States Data!!!');
        }
    };

    const initializeData = (data: EmployeePay) => {
        let newData: EmployeePay = { ...data };

        if (newData) {
            newData.changeDate = newData.changeDate ? (moment(newData.changeDate).format('YYYY-MM-DD') as unknown as Date) : null;
            newData.effectiveDate = newData.effectiveDate ? (moment(newData.effectiveDate).format('YYYY-MM-DD') as unknown as Date) : null;
        }

        return newData;
    };

    const initializeVendorSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 50,
            idField: 'VNDR_NO',
            pageNumber: 1,
            columns: []
        };
        setVendorSearchOptions(ODataOptions.from(tableConfig).addOrderBy('VendorNumber', ODataOrderByDirection.Ascending));
    };

    /**
     * @returns United States (Merica) not React states
     */
    const stateDropdownOptions = () => {
        return states
            ? states?.items?.map((st: State) => {
                return { value: st.id, label: st.name };
            })
            : [];
    };

    const onSubmit = async (data: Vendor) => {
        onSaveVendor(data);
    };

    const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    };

    const hideDialog = () => {
        dispatch(actions.layout.hideDialog());
    };

    const handleTerms = (t: Term[]) => {
        console.log(t);
        setTerms(t);

        let descriptions = t?.map(term => ({
            value: term.description,
            label: term.description
        }));

        setTermDescriptions(descriptions);
        console.log(terms);
    };

    const buttonClick = () => {
        console.log('Button Clicked');
    };

    const onSaveVendor = async (data: Vendor) => {
        // console.log(getValues(`termNumber`));
        console.log(dirtyFields);
        if (isDirty) {
            if (getValues(`vendorNumber`) === '') {
                addVendor(getPreparedCreateVendorPayload(data, true));
            } else {
                updateVendor(getPreparedCreateVendorPayload(data, false));
            }
        }
    };

    const getTermNumber = (term: string) => {
        let targetTerm = terms.find(t =>
            t.description === term
            );
        return Number(targetTerm?.id !== undefined ? targetTerm?.id : '0');
    };

    const getPreparedCreateVendorPayload = (data: Vendor, create: boolean) => {
        let createVendorPayload = {
            address: data.address,
            city: data.city,
            emailAddress: data.emailAddress,
            faxNumber: data.faxNumber,
            isActive: 1,
            phoneNumber: data.phoneNumber,
            stateId: data.state,
            taxId: data.taxId,
            taxType: GetIrsCategoryTypeIdFromString(data.taxType),
            termNumber: data.termNumber !== undefined ? getTermNumber(data.termNumber.toString()) : 0,
            useSsn: data.useSsn,
            VendorName: data.vendorName,
            VendorNumber: !!create ? 0 : Number(data.vendorNumber),
            zipCode: data.zipCode
        };
        return ((createVendorPayload as unknown) as Vendor);
    };

    const GetIrsCategoryTypeIdFromString = (irsCategoryTypeString: string) => {
        switch (irsCategoryTypeString) {
            case 'Gross Proceeds Paid to Attorney':
            return '1';
        default:
            return '2';
        }
    };

    const removeVendor = async () => {
        const vendorNumber = vendors.items[selectedVendor].vendorNumber;
        let result = await del(`/v1.0/AccountsPayable/vendor/${vendorNumber}`);

        if (response.ok) {
            getVendors('');
        } else {
            console.log('Unable to delete charge vendor!' + result);
        }
    };

    const removeVendorDefaultAccount = async () => {
        const vendorNumber = vendors?.items[selectedVendor]?.vendorNumber;
        const accountNumber = vendorDefaultAccounts[selectedVendorDefaultAccount].accountNumber;
        let result = await del(`/v1.0/AccountsPayable/vendordefaultaccount?vendorNumber=${vendorNumber}&accountNumber=${accountNumber}`);

        if (response.ok) {
            getVendorDefaultAccounts(vendorNumber);
        } else {
            console.log('Unable to delete charge vendor!' + result);
        }
    };

    const addDefaultVendorAccount = async (vendorAccount: LedgerAccount) => {
        const vendorNumber = vendors.items[selectedVendor].vendorNumber;
        const payload = {
            vendorNumber: vendorNumber,
            accountNumber: vendorAccount.accountNumber
        };

        let result = await post(`/v1.0/AccountsPayable/vendors/defaultaccount/create`, payload);

        if (response.ok) {
            getVendorDefaultAccounts(vendorNumber);
        } else {
            console.log('Unable to add a vendor default account!' + result);
        }
    };

    const prepAddVendor = () => {
        reset(new Vendor());
        setValue(`vendorNumber`, 0);
        const vendorNameField = document.getElementById(`1vendorName1`);
        if (!!vendorNameField) {
            vendorNameField.focus();
        }
    };

    const addVendor = async (payload: Vendor) => {
        if (isDirty) {
            /*const formData = getValues();
             const payload = {
                vendorName: dirtyFields.vendorName,
                vendorName2: formData.vendorName2,
                address: formData.address,
                address2: formData.address2,
                city: formData.city,
                state: formData.state,
                zipCode: formData.zipcode,
                termNumber: formData.termNumber,
                phoneNumber: formData.phoneNumber,
                faxNumber: formData.faxNumber,
                emailAddress: formData.emailAddress,
                vendorAccount: formData.vendorAccountForTSDI1,
                contact: '',
                webPage: '',
                comments: '',
                taxId: formData.taxId,
                isHidden: '',
                taxType: GetIrsCategoryTypeIdFromString(formData.taxType),
                useSsn: formData.useSsn,
                isActive: formData.isActive === true ? 1 : 0
            }; */

            let result = await post(`/v1.0/AccountsPayable/vendors/create`, payload);

            if (response.ok) {
                getVendors('');
            } else {
                console.log('Unable to add vendor!' + result);
            }
        }
    };

    const updateVendor = async (payload: Vendor) => {
        if (isDirty) {
            /* const formData = getValues();
            const payload = {
                vendorNumber: vendors?.items[selectedVendor]?.vendorNumber,
                vendorName: formData.vendorName,
                vendorName2: formData.vendorName2,
                address: formData.address,
                address2: formData.address2,
                city: formData.city,
                state: formData.state,
                zipCode: formData.zipcode,
                termNumber: getTermNumber(formData.termNumber),
                phoneNumber: '',
                faxNumber: formData.fax,
                emailAddress: formData.email,
                vendorAccount: formData.vendorAccountForTSDI1,
                contact: '',
                webPage: '',
                comments: '',
                taxId: formData.taxIdNumber,
                isHidden: '',
                taxType: GetIrsCategoryTypeIdFromString(formData.taxType),
                useSsn: '',
                isActive: formData.isActive === true ? 1 : 0
            }; */

            console.log(payload);

            let result = await put(`/v1.0/AccountsPayable/vendor`, payload);

            if (response.ok) {
                getVendors('');
            } else {
                console.log('Unable to update vendor!' + result);
            }
        }
    };

    const nextButtonClicked = () => {
        const newlySelectedVendor = selectedVendor < vendors?.items?.length ? selectedVendor + 1 : selectedVendor;
        if (selectedVendor >= vendors?.items?.length - 1) {
            incrementVendors();
        }
        setSelectedVendor(newlySelectedVendor);
        getVendorDefaultAccounts(vendors?.items[newlySelectedVendor]?.vendorNumber);
    };

    const previousButtonClicked = () => {
        const newlySelectedVendor = selectedVendor > 0 ? selectedVendor - 1 : 0;
        setSelectedVendor(newlySelectedVendor);
        getVendorDefaultAccounts(vendors?.items[newlySelectedVendor]?.vendorNumber);
    };    
/*     const addVendor = () => {
    const findVendor = () => {
        showDialog(DialogList.FIND_VENDOR);
    };

    const addVendor = () => {
        showDialog(DialogList.ADD_VENDOR);
    }; */

    const findVendor = () => {
        dispatch(actions.layout.showDialog(DialogList.FIND_VENDOR));
    };

    const findAvailableAccounts = () => {
        dispatch(actions.layout.showDialog(DialogList.FIND_AVAILABLE_ACCOUNTS));
    };

    const addTerms = () => {
        showDialog(DialogList.AP_TERMS);
    };

    const reports = () => {
        showDialog(DialogList.VENDOR_REPORTS);
    };

    const goToLastRecord = () => {
        setSelectedVendor(vendors.items.length - 1);
    };

    const addNewDefaultVendorAccount = (account: LedgerAccount) => {
        // This is where we'll call the service to add a new default vendor account
        addDefaultVendorAccount(account);
    };

    const displayWarning = (index: number) => {
        setSelectedVendorDefaultAccount(index);
        showDialog(DialogList.WARNING);
    };

    const handleConfirmDeleteVendorDefaultAccount = () => {
        removeVendorDefaultAccount();
        console.log('Delete Default vendor account');
    };

    const incrementVendors = () => {
        if (!!fetchNextPage) {
            // setFetchNextPage(vendors.pageNumber * vendors.pageSize < vendors.totalRecords);
            let newSearchOptions = _.cloneDeep(vendorSearchOptions);
            newSearchOptions.incrementPageNumber();
            setVendorSearchOptions(newSearchOptions);
        }
    };

    const displayAccounts = () => {
        return <div>
            <table style={{ width: '100%' }}>
                <thead style={{ textAlign: 'left' }}>
                    <tr>
                        <th>Account No.</th>
                        <th>Description</th>
                    </tr>
                </thead>
                {vendorDefaultAccounts?.map((account: VendorDefaultAccount, index: number) => {
                    return (
                        <tbody key={account.id}>
                            <tr className="table-item-hover">
                                <td style={{ width: '30%' }}>
                                    <RHFInputBox
                                        name={`accounts[${index}].accountNumber`}
                                        type="text"
                                        defaultVal={account.accountNumber + ''}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}                                        
                                        onDoubleClick={() => findAvailableAccounts()}
                                    />
                                </td>
                                <td style={{ width: '70%' }}>
                                    <RHFInputBox
                                        name={`accounts[${index}].description`}
                                        type="text"
                                        defaultVal={account.description + ''}
                                        register={register}
                                        errors={errors}
                                        style={{ width: '100%' }}
                                        bodyStyle={{ width: '100%' }}
                                    />
                                </td>
                                <td style={{ width: '70%' }}>
                                    <div className="form-row" style={{ margin: 0 }}>
                                        <Button 
                                            className="blue-hover-button"
                                            reactIcon={FaPlusCircle}
                                            iconStyle={{width: '1.5rem', height: '1.5rem', marginBottom: '.5rem'}}
                                            style={{ height: '3rem', background: 'transparent', padding: '0 1 0 0' }} 
                                            onClick={() => findAvailableAccounts()}
                                            title="Add New Default Account"
                                        />
                                        <Button 
                                            reactIcon={IoMdCloseCircleOutline} 
                                            iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                            iconHoverColor="red"
                                            title="Remove Default Account"
                                            style={{ height: '3rem', background: 'transparent', padding: '0 0 0 0', marginTop: '.4rem' }} 
                                            onClick={() => displayWarning(index)}
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    );
                })}
            </table>
        </div>;
    };

    return (
        <div>
            <APNavBar/>
            <form id="employeePayForm" onSubmit={handleSubmit(onSubmit)}>
                <Page>
                    <Page.Section width={12}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel>
                                <div className="form-row" style={{ textAlign: 'center', verticalAlign: 'middle', justifyContent: 'center', margin: 0, padding: 0 }}>
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '14%', height: '3rem' }}
                                        text={'Find'}
                                        onClick={() => findVendor()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Add (Clear form)'}
                                        onClick={() => prepAddVendor()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Delete'}
                                        onClick={removeVendor}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Previous'}
                                        onClick={previousButtonClicked}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Next'}
                                        onClick={nextButtonClicked}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Save'}
                                        type={'submit'}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Reports'}
                                        onClick={() => reports()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Go to Last Record'}
                                        onClick={() => goToLastRecord()}
                                    />
                                    {/* <Button
                                        className="blue-hover-button"
                                        style={{ width: '10%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Reoccuring'}
                                        onClick={() => buttonClick}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '10%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Exit'}
                                        onClick={() => buttonClick}
                                    /> */}
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                </Page>
                <Page>
                    <Page.Section width={12}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel panelTitle="A/P Vendors">
                                <div style={{ padding: '.5rem' }}>
                                    <div className="form-row">
                                        <RHFInputBox
                                            disabled={true}
                                            label="Vendor No."
                                            name={`vendorNumber`}
                                            type="number"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                            onDoubleClick={findVendor}
                                        />
                                        <RHFInputBox
                                            label="Name"
                                            id={`1vendorName1`}
                                            name={`vendorName`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%' }}
                                        />
                                        {isAccountingAdmin && <RHFCheckbox
                                            name="isHidden"
                                            checked={vendors?.items[selectedVendor]?.isHidden === 'Y' ? true : false}
                                            label="Hidden"
                                            register={register}
                                            errors={errors}
                                            bodyStyle={{ width: '10%', marginTop: '1rem' }}
                                        />}
                                        <RHFCheckbox
                                            name="isActive"
                                            checked={vendors?.items[selectedVendor]?.isActive === 1 ? true : false}
                                            label="Active"
                                            register={register}
                                            errors={errors}
                                            bodyStyle={{ width: '10%', marginTop: '1rem' }}
                                        />
                                        <Button
                                            className="blue-hover-button"
                                            style={{ width: '10%', height: '3rem', marginTop: '2rem' }}
                                            text={'Documents'}
                                            onClick={() => buttonClick}
                                        />
                                        <RHFInputBox
                                            name={`documents`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '10%', marginTop: '2rem' }}
                                        />
                                    </div>
                                    <div className="form-row">
                                        <RHFInputBox
                                            label="Address"
                                            name={`address`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                        />
                                        <RHFInputBox
                                            label="City"
                                            name={`city`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%' }}
                                        />
                                        <RHFSelect
                                            bodyStyle={{ width: '20%' }}
                                            style={{ width: '100%' }}
                                            name="stateId"
                                            label="State"
                                            options={stateDropdownOptions()}
                                            register={register}
                                            errors={errors}
                                        />
                                        {/* <RHFInputBox
                                            label="State"
                                            name={`state`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '20%' }}
                                        /> */}
                                        <RHFInputBox
                                            label="Zip Code"
                                            name={`zipCode`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '20%' }}
                                        />
                                    </div>
                                    <div className="form-row">
                                        <RHFInputBox
                                            label="Phone"
                                            name={`phoneNumber`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%', marginLeft: '.5rem' }}
                                        />
                                        <RHFInputBox
                                            label="FAX"
                                            name={`faxNumber`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%' }}
                                        />
                                        <RHFInputBox
                                            label="E-Mail"
                                            name={`emailAddress`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '20%' }}
                                        />
                                        <RHFSelect
                                            label="Tax ID No."
                                            name={'useSsn'}
                                            defaultVal={vendors?.items[selectedVendor]?.useSsn}
                                            options={[
                                                { value: 'N', label: 'EIN' },
                                                { value: 'Y', label: 'SSN' },
                                            ]}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '20%' }}
                                        />
                                    </div>
                                    <div className="form-row">
                                        <Button
                                            className="blue-hover-button"
                                            style={{ width: '10%', height: '3rem', marginTop: '2rem' }}
                                            text={'Add Terms'}
                                            onClick={() => addTerms()}
                                        />
                                        <RHFSelect
                                            label="Terms"
                                            name={'termNumber'}
                                            defaultVal={vendors?.items[selectedVendor]?.termNumber + ''}
                                            options={termDescriptions ? termDescriptions : [
                                                { value: '0', label: 'Upon Receipt' },
                                                { value: '1', label: 'Net 15' },
                                                { value: '2', label: 'Net 30' },
                                                { value: '3', label: 'Net 45' },
                                                { value: '-1', label: 'Other' },
                                            ]}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '20%', marginLeft: '.5rem' }}
                                        />
                                        <RHFSelect
                                            label="IRS Category Type"
                                            name={'taxType'}
                                            defaultVal={vendors?.items[selectedVendor]?.taxType}
                                            options={[
                                                { value: 'G', label: 'Gross Proceeds Paid to Attorney' },
                                                { value: 'C', label: 'Nonemployee Compensation' },
                                                { value: 'X', label: 'Not Defined' },
                                                { value: 'N', label: 'Not Eligible - Entity Type' },
                                                { value: 'O', label: 'Not Eligible - Other' },
                                                { value: 'V', label: 'Not Eligible - Vendor Type' },
                                                { value: 'I', label: 'Other Income' },
                                                { value: 'R', label: 'Rents' },
                                            ]}
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '30%' }}
                                        />
                                        {isAccountingAdmin && <RHFInputBox
                                            label="Vendor Account for TSDI"
                                            name={`vendorAccount`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '20%' }}
                                        />}
                                        <RHFInputBox
                                            label="Tax ID"
                                            name={`taxId`}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            style={{ width: '100%' }}
                                            bodyStyle={{ width: '20%' }}
                                        />
                                    </div>
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                </Page>
                <Page>
                    <Page.Section width={12}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel panelTitle="A/P Vendor Default Accounts">
                                <div className="tiny-panel" style={{ width: '100%', textAlign: 'center', overflowY: 'scroll' }}>
                                    {displayAccounts()}
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                </Page>
                <VendorReportsDialog
                    dialogName={DialogList.VENDOR_REPORTS}
                    hideDialog={hideDialog}
                    showDialog={showDialog}
                />
                <AddVendorExDialog
                    dialogName={DialogList.ADD_VENDOR}
                    hideDialog={hideDialog}
                    states={states?.items}
                    termDescriptions={termDescriptions}
                />
                <FindVendorDialog
                    incrementVendors={incrementVendors}
                    resetVendorSearchOptions={resetVendorSearchOptions}
                    dialogName={DialogList.FIND_VENDOR} 
                    hideDialog={hideDialog}
                    vendors={vendors?.items}
                    setVendorSearchTerm={setVendorSearchTerm}
                    setSelectedVendor={setSelectedVendor}
                />
                <WarningDialog 
                    dialogName={DialogList.WARNING} 
                    hideDialog={hideDialog}
                    handleConfirm={handleConfirmDeleteVendorDefaultAccount}
                />
                <FindAvailableAccountsDialog 
                    dialogName={DialogList.FIND_AVAILABLE_ACCOUNTS} 
                    handleOKClicked={addNewDefaultVendorAccount}
                    hideDialog={hideDialog}
                />
                <APTermsDialog
                    dialogName={DialogList.AP_TERMS}
                    hideDialog={hideDialog}
                    handleTerms={handleTerms}
                />
                <ExcelFileDialog
                    dialogName={DialogList.EXCEL_FILE}
                    hideDialog={hideDialog}
                />
            </form>
        </div>
    );
};

export default VendorsPage;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/pages/VendorsPage.tsx